var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRheumatology(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 397 397",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#030303",
    d: "M69.5 27.5h80c-.167 29.002 0 58.002.5 87l2.5 2.5c21.833 6.812 33.833 21.645 36 44.5-2.897 27.23-17.897 42.563-45 46-13.445-.365-24.779-5.365-34-15-18.17 17.338-38.17 19.505-60 6.5-17.51-14.81-22.677-33.31-15.5-55.5 6.668-14.006 17.501-22.84 32.5-26.5a6.977 6.977 0 002.5-3.5c.5-28.665.667-57.331.5-86z",
    opacity: 0.901
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#030202",
    d: "M267.5 27.5c44.808-4.058 78.142 13.442 100 52.5 19.208 47.416 9.541 87.083-29 119-11.916 8.136-24.916 13.636-39 16.5v22c3.606-.289 7.106.044 10.5 1 .969 38.372.636 76.705-1 115-9.972 19.707-24.805 24.373-44.5 14-5.632-4.463-9.465-10.129-11.5-17a3134.683 3134.683 0 010-112c3.333-1.333 6.667-1.333 10 0 .5-7.659.666-15.326.5-23-41.391-9.891-66.891-35.558-76.5-77-4.439-36.362 7.061-66.529 34.5-90.5 13.888-10.466 29.221-17.3 46-20.5z",
    opacity: 0.896
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#717171",
    d: "M290.5 39.5a136.879 136.879 0 00-28 2c2.649-1.61 5.649-2.443 9-2.5 6.514-.82 12.847-.653 19 .5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#5c5c5c",
    d: "M293.5 39.5c2.995-.206 5.662.46 8 2-2.928-.065-5.595-.732-8-2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#969696",
    d: "M137.5 114.5a1406.587 1406.587 0 01-1-75h-54c.331 24.839-.002 49.506-1 74v-75h56v76z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#eaeaeb",
    d: "M137.5 114.5c2.102 8.435 7.435 13.435 16 15 .473 1.406 1.473 2.073 3 2 6.956 2.632 11.956 7.299 15 14-.073 1.527.594 2.527 2 3 .934 1.068 1.268 2.401 1 4 .631 6.295-.202 12.295-2.5 18-13.764 13.903-29.597 16.736-47.5 8.5a66.395 66.395 0 01-11-8c-.529-2.429-1.863-4.262-4-5.5-15.439 19.121-34.105 22.955-56 11.5-2.6-3.112-5.6-5.612-9-7.5.237-1.291-.096-2.291-1-3-2.225-13.33 2.108-24.164 13-32.5a10.136 10.136 0 014-1.5c2.657-.435 4.99-1.435 7-3 7.845-2.514 12.512-7.848 14-16a1369.586 1369.586 0 001-74h54c-.331 25.172.002 50.172 1 75z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e7",
    d: "M290.5 39.5h3c2.405 1.268 5.072 1.935 8 2h1c2.508 2.054 5.508 3.054 9 3 14.671 6.27 27.171 15.603 37.5 28a47.868 47.868 0 014.5 8c.865 3.788 2.532 7.121 5 10 .84 4.583 2.174 8.916 4 13-.241 2.398.426 4.398 2 6v23c-1.157 2.773-1.824 5.773-2 9a123.656 123.656 0 01-9 23c-1.406.473-2.073 1.473-2 3-7.789 12.121-18.122 21.454-31 28-1.527-.073-2.527.594-3 2a5.727 5.727 0 00-3 1c-2.467.255-4.467 1.255-6 3a20.69 20.69 0 00-5 1c-3.227.176-6.227.843-9 2h-4a151.09 151.09 0 01-30-2 43.29 43.29 0 01-17-6c-.473-1.406-1.473-2.073-3-2-16.186-8.93-27.852-21.93-35-39 .073-1.527-.594-2.527-2-3a87.925 87.925 0 00-2-9c-.065-2.928-.732-5.595-2-8 .134-1.792-.199-3.458-1-5a168.29 168.29 0 011-23c-.284-1.915.049-3.581 1-5 1.972-2.584 2.972-5.584 3-9v-1c1.745-1.533 2.745-3.533 3-6 6.577-15.079 16.91-26.912 31-35.5a35.287 35.287 0 0113-5.5c2.467-.255 4.467-1.255 6-3l6-1a136.879 136.879 0 0128-2z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#8f8f8f",
    d: "M256.5 42.5c-1.533 1.745-3.533 2.745-6 3 1.533-1.745 3.533-2.745 6-3z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#8e8e8e",
    d: "M302.5 41.5c3.246.554 6.246 1.554 9 3-3.492.054-6.492-.946-9-3zM270.5 50.5c-3.083 1.493-6.417 2.493-10 3 .111-.617.444-1.117 1-1.5a70.523 70.523 0 019-1.5z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#07080a",
    d: "M270.5 50.5c15.027-1.392 29.36.942 43 7 .473 1.406 1.473 2.073 3 2 13.99 7.964 24.323 19.297 31 34a97.536 97.536 0 015 14c2.436 15.849.436 31.183-6 46-1.745 1.533-2.745 3.533-3 6a111.781 111.781 0 00-7 8.5c-1.782.122-3.448-.378-5-1.5-.979-1.645-2.312-2.979-4-4 5.583-6.502 9.583-13.835 12-22 2.126-3.945 3.126-8.278 3-13v-10c.535-4.812-.465-9.145-3-13 .09-2.652-.576-4.986-2-7 .073-1.527-.594-2.527-2-3-7.458-14.898-19.124-24.898-35-30-1.43-1.038-3.097-1.704-5-2h-1c-4.934-1.883-9.934-2.217-15-1h-3c-3.989-.384-7.655.283-11 2-2.398-.24-4.398.426-6 2-15.501 6.166-26.834 16.832-34 32-1.424 2.014-2.09 4.348-2 7-3.559 10.778-3.892 21.778-1 33 .56 2.301 1.06 4.634 1.5 7 .383.556.883.889 1.5 1 8.22 18.714 22.22 30.881 42 36.5 10.356.704 20.689.537 31-.5 2.467-.255 4.467-1.255 6-3a19.25 19.25 0 006.5-3 25.593 25.593 0 004.5 4c1.86 4.164.527 6.83-4 8-2.657.435-4.991 1.435-7 3h-1a130.434 130.434 0 00-11 3h-1a143.814 143.814 0 01-29-2c-12.678-3.178-23.512-9.512-32.5-19a286.211 286.211 0 01-12.5-17c-.255-2.467-1.255-4.467-3-6v-1c-.554-3.246-1.554-6.246-3-9a19.22 19.22 0 01-1-6 156.383 156.383 0 01-1-22l2-7c1.037-1.43 1.704-3.097 2-5 .912-5.155 2.912-9.822 6-14 1.406-.473 2.073-1.473 2-3 9.893-13.9 22.893-23.566 39-29 3.583-.507 6.917-1.507 10-3z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#636363",
    d: "M313.5 57.5c1.527-.073 2.527.594 3 2-1.527.073-2.527-.594-3-2z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#606060",
    d: "M103.5 50.5c.979 3.125 1.313 6.458 1 10h-12v-11c3.871-.315 7.538.018 11 1z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#070707",
    d: "M103.5 50.5v9h-10v-9h10z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#103342",
    d: "M279.5 61.5c5.066-1.217 10.066-.883 15 1-4.993-.416-9.993-.75-15-1z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#207092",
    d: "M276.5 61.5c-3.474 1.025-7.14 1.692-11 2 3.345-1.717 7.011-2.384 11-2z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#38c0f9",
    d: "M276.5 61.5h3c5.007.25 10.007.584 15 1h1c1.135 1.713 2.802 2.38 5 2 15.876 5.102 27.542 15.102 35 30-.073 1.527.594 2.527 2 3 1.424 2.014 2.09 4.348 2 7a380.563 380.563 0 013 13v10c-.617.111-1.117.444-1.5 1a102.65 102.65 0 01-1.5 10c-12.156 19.156-29.489 30.156-52 33v-11c-3.871-.315-7.538.018-11 1-.979 3.125-1.313 6.458-1 10-10.818-.575-20.818-3.742-30-9.5-8.278-6.44-15.278-13.94-21-22.5-.333-1-1-1.667-2-2-2.892-11.222-2.559-22.222 1-33 1.424-2.015 2.09-4.348 2-7 7.166-15.168 18.499-25.834 34-32 2.398.24 4.398-.426 6-2 3.86-.308 7.526-.975 11-2z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#1e6887",
    d: "M295.5 62.5c1.903.296 3.57.962 5 2-2.198.38-3.865-.287-5-2z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#22789b",
    d: "M265.5 63.5c-1.602 1.574-3.602 2.24-6 2 1.602-1.574 3.602-2.24 6-2z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#c4c4c4",
    d: "M93.5 70.5v1l-2 48c-.652-16.701.015-33.034 2-49z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#0c0c0c",
    d: "M93.5 71.5h10v48c-1.424 2.015-2.09 4.348-2 7-4.729 11.062-12.729 18.729-24 23-1.644-.214-3.144.12-4.5 1-.2-1.82-1.034-3.153-2.5-4a51.648 51.648 0 01-1-7h4c1.653-.16 2.986-.826 4-2 7.216-3.897 11.882-9.897 14-18l2-48z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#7c7c7c",
    d: "M93.5 71.5v-1h11a600.941 600.941 0 01-1 49v-48h-10z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#19556e",
    d: "M264.5 88.5c-3.462.982-7.129 1.315-11 1v-12h12c.315 3.871-.018 7.538-1 11z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#010407",
    d: "M264.5 88.5h-10v-10h10v10z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#afafaf",
    d: "M353.5 80.5c2.701 2.735 4.368 6.069 5 10-2.468-2.879-4.135-6.212-5-10z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#6e6e6e",
    d: "M221.5 82.5c.073 1.527-.594 2.527-2 3-.073-1.527.594-2.527 2-3z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#7d7d7d",
    d: "M206.5 86.5c-.255 2.467-1.255 4.467-3 6 .255-2.467 1.255-4.467 3-6z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#306481",
    d: "M318.5 95.5h-10c3.396-2.362 6.729-2.362 10 0z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#08080a",
    d: "M308.5 95.5h10c12.12 4.001 15.786 12.001 11 24 3.246 6.87 2.413 13.204-2.5 19-12.24 9.707-21.573 7.373-28-7-.918-4.243-.418-8.243 1.5-12-4.286-10.475-1.62-18.475 8-24z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#9e9e9e",
    d: "M203.5 93.5c-.028 3.416-1.028 6.416-3 9 .19-3.355 1.19-6.355 3-9z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d6987",
    d: "M335.5 94.5c1.406.473 2.073 1.473 2 3-1.406-.473-2.073-1.473-2-3z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#b0b0b0",
    d: "M347.5 93.5c3.605 3.855 5.271 8.522 5 14a97.536 97.536 0 00-5-14z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#1e6e8e",
    d: "M225.5 97.5c.09 2.652-.576 4.985-2 7-.09-2.652.576-4.986 2-7z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#acacac",
    d: "M358.5 90.5c2.398 3.903 3.731 8.236 4 13-1.826-4.084-3.16-8.417-4-13z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#7a7a7a",
    d: "M213.5 99.5c-.296 1.903-.963 3.57-2 5-.38-2.198.287-3.865 2-5z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#0b0a0d",
    d: "M251.5 138.5l-10-1a57.42 57.42 0 01-9-9c-2.28-17.053 5.053-24.386 22-22 3.975 2.142 7.142 5.142 9.5 9 2.064 11.214-2.103 18.881-12.5 23z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#91303b",
    d: "M317.5 106.5a21.435 21.435 0 00-7 1c.812-1.493 2.145-2.16 4-2 1.226.02 2.226.353 3 1z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#626262",
    d: "M362.5 103.5c1.574 1.602 2.241 3.602 2 6-1.574-1.602-2.241-3.602-2-6z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#842e35",
    d: "M310.5 107.5v7c-2.667-2.333-2.667-4.667 0-7z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#000102",
    d: "M276.5 111.5h10v10h-10v-10z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#19617e",
    d: "M276.5 111.5c3.462-.982 7.129-1.315 11-1v12c-3.871.315-7.538-.018-11-1h10v-10h-10z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f6c8c",
    d: "M339.5 104.5c2.535 3.855 3.535 8.188 3 13a380.563 380.563 0 00-3-13z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#e85260",
    d: "M245.5 116.5c7.668.007 9.668 3.34 6 10-6.307 1.859-9.14-.474-8.5-7a10.515 10.515 0 002.5-3z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#3b3b3b",
    d: "M199.5 107.5a168.29 168.29 0 00-1 23c-1.154-6.487-1.321-13.154-.5-20 .232-1.237.732-2.237 1.5-3z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#ee5463",
    d: "M317.5 106.5c1.978.817 2.978 2.317 3 4.5a44.843 44.843 0 01-4 8c.317 2.328 1.484 4.161 3.5 5.5 1.312 4.734-.355 7.401-5 8-5.09-.349-6.757-3.015-5-8 3.144-3.192 3.31-6.525.5-10v-7a21.435 21.435 0 017-1z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#959595",
    d: "M103.5 119.5c.09 2.652-.576 4.985-2 7-.09-2.652.576-4.985 2-7z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#b0b0b0",
    d: "M209.5 111.5c-.183 7.368.15 14.701 1 22-.768-.763-1.268-1.763-1.5-3-.82-6.514-.653-12.847.5-19z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "M153.5 129.5c1.527-.073 2.527.594 3 2-1.527.073-2.527-.594-3-2z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#969696",
    d: "M67.5 129.5c-2.01 1.565-4.343 2.565-7 3 1.676-2.334 4.009-3.334 7-3z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f749b",
    d: "M342.5 127.5c.126 4.722-.874 9.055-3 13v-2a102.65 102.65 0 001.5-10c.383-.556.883-.889 1.5-1z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#5a5a5a",
    d: "M364.5 132.5c.432 3.377-.235 6.377-2 9 .176-3.227.843-6.227 2-9z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    d: "M199.5 135.5c1.268 2.405 1.935 5.072 2 8-1.723-2.28-2.389-4.947-2-8z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#767676",
    d: "M77.5 137.5c-1.014 1.174-2.347 1.84-4 2 .787-1.604 2.12-2.271 4-2z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#455c76",
    d: "M241.5 137.5l10 1c-3.459 1.365-6.792 1.031-10-1z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#0b4b77",
    d: "M222.5 137.5c1 .333 1.667 1 2 2a19.22 19.22 0 001 6c-.617-.111-1.117-.444-1.5-1-.44-2.366-.94-4.699-1.5-7z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#777",
    d: "M171.5 145.5c1.406.473 2.073 1.473 2 3-1.406-.473-2.073-1.473-2-3z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#a3a3a3",
    d: "M211.5 139.5c1.446 2.754 2.446 5.754 3 9-1.149-.291-1.816-1.124-2-2.5a29.495 29.495 0 01-1-6.5z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#868686",
    d: "M70.5 146.5c1.466.847 2.3 2.18 2.5 4 1.356-.88 2.856-1.214 4.5-1-1.714 1.238-3.714 1.905-6 2a20.676 20.676 0 00-1-5z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#158adb",
    d: "M339.5 138.5v2c-2.417 8.165-6.417 15.498-12 22 1.688 1.021 3.021 2.355 4 4a146.272 146.272 0 01-16 13 25.593 25.593 0 01-4.5-4 19.25 19.25 0 01-6.5 3c-2.467.255-4.467 1.255-6 3a184.315 184.315 0 01-31 .5c-19.78-5.619-33.78-17.786-42-36.5a19.22 19.22 0 01-1-6c5.722 8.56 12.722 16.06 21 22.5 9.182 5.758 19.182 8.925 30 9.5-.313-3.542.021-6.875 1-10v10c3.667 1.333 7.333 1.333 11 0 22.511-2.844 39.844-13.844 52-33z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#6c6c6c",
    d: "M203.5 152.5c1.406.473 2.073 1.473 2 3-1.406-.473-2.073-1.473-2-3z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#939393",
    d: "M214.5 149.5c1.745 1.533 2.745 3.533 3 6-1.745-1.533-2.745-3.533-3-6z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#989898",
    d: "M346.5 153.5c-.255 2.467-1.255 4.467-3 6 .255-2.467 1.255-4.467 3-6z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#000101",
    d: "M276.5 161.5h10v10h-10v-10z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#145472",
    d: "M276.5 161.5c3.462-.982 7.129-1.315 11-1v11c-3.667 1.333-7.333 1.333-11 0h10v-10h-10z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#5b5b5b",
    d: "M353.5 164.5c.073 1.527-.594 2.527-2 3-.073-1.527.594-2.527 2-3z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#6b727a",
    d: "M43.5 166.5c.904.709 1.237 1.709 1 3l1 4c-.617-.111-1.117-.444-1.5-1a18.437 18.437 0 01-.5-6z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#b3bdca",
    d: "M174.5 152.5c3.876 15.644-.791 28.144-14 37.5-12.06 5.924-24.06 5.924-36 0-5.85-5.565-10.85-11.732-15-18.5-12.181 22.626-29.848 28.459-53 17.5-5.295-4.119-8.962-9.285-11-15.5l-1-4c3.4 1.888 6.4 4.388 9 7.5 21.895 11.455 40.561 7.621 56-11.5 2.137 1.238 3.471 3.071 4 5.5a66.395 66.395 0 0011 8c17.903 8.236 33.736 5.403 47.5-8.5 2.298-5.705 3.131-11.705 2.5-18z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#062b47",
    d: "M304.5 178.5c-1.533 1.745-3.533 2.745-6 3 1.533-1.745 3.533-2.745 6-3z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#9d9d9d",
    d: "M311.5 187.5c-1.676 2.334-4.009 3.334-7 3 2.009-1.565 4.343-2.565 7-3z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#a0a0a0",
    d: "M303.5 190.5c-.291 1.149-1.124 1.816-2.5 2a31.881 31.881 0 01-8.5 1 130.434 130.434 0 0111-3z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#626262",
    d: "M262.5 191.5a143.814 143.814 0 0029 2c-6.821 1.155-13.821 1.321-21 .5-3.022-.098-5.689-.932-8-2.5z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#6d6d6d",
    d: "M240.5 194.5c1.527-.073 2.527.594 3 2-1.527.073-2.527-.594-3-2z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#646464",
    d: "M320.5 195.5c-.473 1.406-1.473 2.073-3 2 .473-1.406 1.473-2.073 3-2z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#020303",
    d: "M107.5 199.5c1.322-.17 2.489.163 3.5 1 10.742 20.578 26.908 26.745 48.5 18.5a45.689 45.689 0 008.5-7.5 52.17 52.17 0 017-10c19.966 26.419 17.466 50.419-7.5 72a55.94 55.94 0 01-16 6.5 9.454 9.454 0 00-1.5 2.5c-.5 29.998-.667 59.998-.5 90h-80c.167-29.669 0-59.335-.5-89a11.357 11.357 0 00-1.5-3.5c-27.566-8.265-39.4-26.765-35.5-55.5 2.192-8.744 6.358-16.411 12.5-23 8.592 16.963 22.259 23.796 41 20.5 10.885-4.051 18.218-11.551 22-22.5z",
    opacity: 0.901
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "#4e4e4e",
    d: "M314.5 198.5c-1.533 1.745-3.533 2.745-6 3 1.533-1.745 3.533-2.745 6-3z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "#636363",
    d: "M303.5 202.5c-2.671 1.618-5.671 2.285-9 2 2.773-1.157 5.773-1.824 9-2z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "#8b8b8b",
    d: "M260.5 202.5a151.09 151.09 0 0030 2c-6.821 1.155-13.821 1.321-21 .5-3.351-.057-6.351-.891-9-2.5z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5c0cd",
    d: "M276.5 216.5h10v22h-10v-22z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "#5f656b",
    d: "M276.5 216.5c3.462-.982 7.129-1.315 11-1v24c-3.871.315-7.538-.018-11-1h10v-22h-10z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "#e9e9e9",
    d: "M116.5 226.5c.473 1.406 1.473 2.073 3 2a29.555 29.555 0 015 3c1.43 1.037 3.097 1.704 5 2 .992-.172 1.658.162 2 1 7.155 1.155 14.488 1.322 22 .5.916-.278 1.582-.778 2-1.5l5-2h4c1.183 10.61-1.65 19.943-8.5 28-3.306 3.694-6.806 7.027-10.5 10-.992-.172-1.658.162-2 1-6.684.28-12.184 2.947-16.5 8a3436.129 3436.129 0 01-1.5 82h-44c.324-27.741-.009-55.407-1-83a21.445 21.445 0 01-1-7 19.222 19.222 0 01-6-1c-1.653-.16-2.986-.826-4-2-2.014-1.424-4.348-2.09-7-2-12.763-6.06-19.43-16.226-20-30.5-.548-4.458.618-8.292 3.5-11.5 5.348 4.941 11.514 8.275 18.5 10 .11.617.444 1.117 1 1.5 7.18.821 14.18.655 21-.5 8.632-2.942 16.299-7.609 23-14 2.353 2.023 4.686 4.023 7 6z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "#565656",
    d: "M116.5 226.5c1.527-.073 2.527.594 3 2-1.527.073-2.527-.594-3-2z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "#b3beca",
    d: "M173.5 247.5c-5.746 11.73-15.079 19.063-28 22 3.694-2.973 7.194-6.306 10.5-10 6.85-8.057 9.683-17.39 8.5-28h-4a44.49 44.49 0 0010-6c.996.086 1.829-.248 2.5-1l1 2a93.349 93.349 0 01-.5 21z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "#545454",
    d: "M124.5 231.5c2.198-.38 3.865.287 5 2-1.903-.296-3.57-.963-5-2z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "#929ba6",
    d: "M173.5 247.5a93.349 93.349 0 00.5-21l-1-2c-.671.752-1.504 1.086-2.5 1 1.479-2.546 2.979-2.546 4.5 0 .667 6 .667 12 0 18-.21 1.558-.71 2.891-1.5 4z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "#838383",
    d: "M64.5 233.5c7.277.93 14.61 1.264 22 1-6.82 1.155-13.82 1.321-21 .5-.556-.383-.89-.883-1-1.5z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "#878787",
    d: "M155.5 233.5c-.418.722-1.084 1.222-2 1.5-7.512.822-14.845.655-22-.5a180.81 180.81 0 0024-1z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "#888",
    d: "M62.5 265.5c2.652-.09 4.986.576 7 2-2.652.09-4.986-.576-7-2z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "#0a0a0a",
    d: "M101.5 271.5a86.613 86.613 0 012 17h-10c.295-2.235-.039-4.235-1-6-.147-4.896-.98-9.563-2.5-14 5.952-6.178 9.785-5.178 11.5 3z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "#8a6d4f",
    d: "M297.5 348.5v-98h-32v97a2401.328 2401.328 0 01-1-98h34c.332 33.171-.002 66.171-1 99z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "#d3a06c",
    d: "M297.5 266.5h-32v-16h32v16z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "#e9bc8b",
    d: "M265.5 266.5h32v82c-2 5.333-5.667 9-11 11-4.93.466-9.597-.201-14-2-3.786-2.214-6.12-5.548-7-10v-81z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5b5b5",
    d: "M73.5 269.5c1.935.65 3.935.983 6 1a21.445 21.445 0 001 7c-1.59-3.261-3.924-5.927-7-8z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "#b6c0cd",
    d: "M143.5 270.5c-3.325 2.985-5.325 6.652-6 11a1560.835 1560.835 0 00-1 79h-11a3436.129 3436.129 0 001.5-82c4.316-5.053 9.816-7.72 16.5-8z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "#6b7075",
    d: "M137.5 281.5v80a784.675 784.675 0 01-56-1h55c-.331-26.505.002-52.839 1-79z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "#747474",
    d: "M101.5 271.5c1.63 1.526 2.463 3.526 2.5 6 .81 3.858.643 7.524-.5 11a86.613 86.613 0 00-2-17z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "#777",
    d: "M92.5 282.5c.961 1.765 1.295 3.765 1 6h10c-3.462.982-7.129 1.315-11 1v-7z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "#626262",
    d: "M103.5 343.5c-3.462.982-7.129 1.315-11 1v-45h12a484.723 484.723 0 01-1 44z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "#030303",
    d: "M103.5 343.5h-10v-43h10v43z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "#6d5941",
    d: "M276.5 349.5c-.982-3.462-1.315-7.129-1-11h12v12c-3.871.315-7.538-.018-11-1z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "#080503",
    d: "M276.5 349.5v-10h10v10h-10z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "#967959",
    d: "M272.5 357.5c4.403 1.799 9.07 2.466 14 2-.111.617-.444 1.117-1 1.5a16.242 16.242 0 01-8 0c-2.381-.223-4.047-1.39-5-3.5z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRheumatology);
export default __webpack_public_path__ + "static/media/rheumatology.b07c94a7.svg";
export { ForwardRef as ReactComponent };